@if (progressService.isLoading()) {
    <du-config-detail-skeleton></du-config-detail-skeleton>
} @else {
    <du-config-detail [navigateBack]="{commands: [ConfigRouteEnum.HOME]}">
        <detail-header>
            @if (logoUrl && logoUrl.length > 0) {
                <img
                        [ngSrc]="logoUrl"
                        alt="JSONata logo"
                        width="64" height="64" priority>
            }
            <div>
                <h1 class="detail-header-title">
                    JSONata Expressions
                </h1>
                <a href="https://docs.jsonata.org/overview.html"
                   target="_blank"
                   class="detail-header-subtitle">
                    {{ 'jsonata.documentation' | translate }}
                </a>
            </div>
        </detail-header>
        <detail-body>
            <p-card class="jsonata-overview-card">
                <div class="layout-column jsonata-overview-container">
                    <div class="jsonata-overview-header responsive-layout">
                        <div class="detail-table-header-left">
                            <p-iconfield>
                                <p-inputicon class="pi pi-search"/>
                                <input pInputText [placeholder]="'search' | translate" [formControl]="searchInput">
                            </p-iconfield>
                        </div>
                        <div class="jsonata-overview-header-actions">
                            <p-button (click)="addJsonataExpression()">
                                <i class="pi pi-plus"></i>
                                {{ 'jsonata.create' | translate | uppercase }}
                            </p-button>
                        </div>
                    </div>

                    <div>
                        <p-table [value]="dataSource" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 100]" sortMode="single">
                            <ng-template #header>
                                <tr>
                                    <th pSortableColumn="id" class="detail-table-header-cell">
                                        ID
                                        <p-sortIcon field="id"/>
                                    </th>
                                    <th pSortableColumn="identification" class="detail-table-header-cell">
                                        {{ 'jsonata.identification' | translate }}
                                        <p-sortIcon field="identification"/>
                                    </th>
                                    <th pSortableColumn="tenantName" class="detail-table-header-cell">
                                        {{ 'jsonata.tenantName' | translate }}
                                        <p-sortIcon field="tenantName"/>
                                    </th>
                                    <th pSortableColumn="active" class="detail-table-header-cell">
                                        {{ 'jsonata.active' | translate }}
                                        <p-sortIcon field="active"/>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template #body let-row>
                                <tr class="jsonata-overview-row-click" (click)="jsonataDetail(row)" (keydown.enter)="jsonataDetail(row)">
                                    <td class="detail-table-body-cell">{{ row.id }}</td>
                                    <td class="detail-table-body-cell">{{ row.identification }}</td>
                                    <td class="detail-table-body-cell">{{ row.tenantName }}</td>
                                    <td class="detail-table-body-cell">{{ 'jsonata.' + row.active | translate }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-card>
        </detail-body>
    </du-config-detail>
}
